import { addToast } from '@heroui/react';
import CryptoJS from 'crypto-js';
import { logError } from './logger';

export const passwordEncrypt = (rawPassword: string): string | null => {
  const ENCRYPTION_KEY = import.meta.env.VITE_APP_PASSWORD_ENCRYPTION_KEY;

  if (!ENCRYPTION_KEY) {
    addToast({
      title: 'Error',
      description: 'Missing configuration',
      radius: 'md',
      color: 'danger',
    });
    return null;
  }
  if (!rawPassword) return null;

  try {
    const encrypted = CryptoJS.AES.encrypt(
      rawPassword,
      ENCRYPTION_KEY
    ).toString();

    return encrypted;
  } catch (error) {
    logError('Encryption failed', { error });
    return null;
  }
};
